<a *ngIf="url" (click)="onUrlClick()" [href]="url" target="_blank">
  <img [src]="image" [alt]="socialLink.type">
</a>
<img *ngIf="!url" class="opacity-30" pTooltip="Unavailable" tooltipPosition="top" [src]="image" [alt]="socialLink.type">